import React, { FunctionComponent, SetStateAction, useState } from "react";
import Bio from "../bio";
import { HandleSpeakerProps, SpeakersListProps } from "../interfaces";
import Modal from "../modals/modal";
import SpeakerListItem from "./speakerListItem";

const SpeakersList: FunctionComponent<SpeakersListProps> = ({ speakers }) => {
  const [modalState, setModalState] = useState(false);
  const [modalData, setModalData] = useState({
    name: "default name",
    position: "default title",
    company: "default company",
    bio: "",
  });
  const handleSpeakerClick: any = (
    speaker: SetStateAction<HandleSpeakerProps>
  ) => {
    setModalData(speaker);
    setModalState(true);
  };

  return (
    <div id="speakersList">
      {speakers
        ?.filter((speaker) => !speaker.disabledProfile)
        .map((speaker) => {
          return (
            <SpeakerListItem speaker={speaker} onClick={handleSpeakerClick} />
          );
        })}
      <Modal
        open={modalState}
        onClose={() => setModalState(false)}
        closable={true}
      >
        <Bio data={modalData} />
      </Modal>
    </div>
  );
};

export default SpeakersList;
